import { atom } from 'jotai'
import { atomFamily } from 'jotai/utils'
import type { SseStep } from '@/app/services/http/sseClient'

export interface CrefisaProgress {
  steps: SseStep[]
}

const EMPTY: CrefisaProgress = { steps: [] }

export const crefisaProgressFamily = atomFamily<
  string,
  ReturnType<typeof atom<CrefisaProgress>>
>(() => atom<CrefisaProgress>(EMPTY))

export function applyStep(
  progress: CrefisaProgress,
  step: SseStep,
): CrefisaProgress {
  const steps = [...progress.steps]
  const index = steps.findIndex((current) => current.key === step.key)

  if (index === -1) steps.push(step)
  else steps[index] = { ...steps[index], ...step }

  return { steps }
}

export function currentStep(progress: CrefisaProgress): SseStep | undefined {
  return [...progress.steps]
    .reverse()
    .find((step) => step.state === 'running' || step.state === 'queued')
}

export const emptyProgress = EMPTY
